import type { ReactNode } from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight, MdSearch } from 'react-icons/md';

type MailListToolbarProps = {
  keyword: string;
  onKeywordChange: (keyword: string) => void;
  placeholder: string;
  rangeLabel: string;
  canGoPrev: boolean;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  action?: ReactNode;
};

const pagerButtonClassName =
  'flex size-6 cursor-pointer items-center justify-center rounded-sm border-none bg-transparent p-0 text-main transition hover:bg-gray disabled:cursor-not-allowed disabled:text-border disabled:hover:bg-transparent';

export default function MailListToolbar({
  keyword,
  onKeywordChange,
  placeholder,
  rangeLabel,
  canGoPrev,
  canGoNext,
  onPrev,
  onNext,
  action,
}: MailListToolbarProps) {
  return (
    <div className="flex w-full items-end justify-between gap-md p-md">
      <div className="flex min-w-0 items-center gap-md">
        <label className="flex w-[458px] max-w-full min-w-0 items-center gap-xs rounded-sm border border-solid border-border bg-white px-sm py-xs focus-within:border-primary">
          <MdSearch className="size-5 shrink-0 text-sub" />
          <input
            type="search"
            value={keyword}
            onChange={(event) => onKeywordChange(event.target.value)}
            placeholder={placeholder}
            aria-label={placeholder}
            className="h-6 min-w-0 flex-1 border-none bg-transparent p-0 text-body-sm text-main outline-hidden placeholder:text-sub"
          />
        </label>
        {action}
      </div>
      <div className="flex h-[26px] shrink-0 items-center gap-sm">
        <span className="text-body-sm whitespace-nowrap text-main">{rangeLabel}</span>
        <div className="flex items-center gap-xxs">
          <button
            type="button"
            aria-label="前のページ"
            className={pagerButtonClassName}
            disabled={!canGoPrev}
            onClick={onPrev}
          >
            <MdKeyboardArrowLeft className="size-6" />
          </button>
          <button
            type="button"
            aria-label="次のページ"
            className={pagerButtonClassName}
            disabled={!canGoNext}
            onClick={onNext}
          >
            <MdKeyboardArrowRight className="size-6" />
          </button>
        </div>
      </div>
    </div>
  );
}
